﻿import React, { useState, useMemo, useContext } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import Table_Head from '@Elements/Table/Table_Head';
import Table_Data from '@Elements/Table/Table_Data';
import Customer_Name_With_Color from '@Elements/Table/Customer_Name_With_Color';
import { Icon_Edit, Icon_Trash } from '@Elements/ImageElements/Icons';

import {
    str_isEmpty,
    generate_unique_id
} from '@Util/Utils';
import {
    Time_Log_Entry,
    Monthly_Report_Table_Data
} from '@Util/Types';

export default function Monthly_Report_Table(props: Monthly_Report_Table_Data): JSX.Element {
    const [t] = useTranslation();

    function Empty_Table(): JSX.Element {
        return (
            <tr>
                <Table_Data align="left">
                    <span className="Table_Data_Customer_Name">{t('Text.NoTimelogObjectsToShow')}</span>
                </Table_Data>
                <Table_Data align="right">
                    <></>
                </Table_Data>
            </tr>
        )
    }

    function return_hour_letter(val: string): string {
        if (Number.isNaN(parseInt(val)))
            return "";

        return "h";
    }

    return (
        <>
            <div className="Table_Wrapper">
                <table className="Table">
                    <thead>
                        <tr key={generate_unique_id()}>
                            {props?.monthlyReportGrid[0]?.map((o: string): JSX.Element =>
                                <Table_Head
                                    align="left"
                                    text={o}
                                />
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props?.monthlyReportGrid?.isEmpty() ?
                                <Empty_Table /> :
                                props?.monthlyReportGrid?.map((o: string[], i: number): JSX.Element => {
                                    if (i != 0) {
                                        return (
                                            <tr key={generate_unique_id()}>
                                                {o.map((a: string): JSX.Element =>
                                                    <Table_Data
                                                        align="left"
                                                        className="Table_Data_With_Buttons"
                                                    >
                                                        <span>{`${a.replace(".", ",")} ${return_hour_letter(a)}`}</span>
                                                    </Table_Data>
                                                )}
                                            </tr>
                                        )
                                    }
                                })
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
}